import { render } from "./CheckboxSetting.vue?vue&type=template&id=558bbc94&scoped=true"
import script from "./CheckboxSetting.vue?vue&type=script&lang=ts"
export * from "./CheckboxSetting.vue?vue&type=script&lang=ts"

import "./CheckboxSetting.vue?vue&type=style&index=0&id=558bbc94&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-558bbc94"

export default script